import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";

const LANG_NAME = { en: { fr: "French", en: "English" } };

export const MessageText = ({ m, mine, lang, convId }) => {
  const fr = lang === "fr";
  const auto = !mine && m.translation && m.translation.lang === lang ? m.translation.text : null;
  const [manual, setManual] = useState(null);
  const [busy, setBusy] = useState(false);
  const [showOrig, setShowOrig] = useState(true);
  const text = manual && manual.lang === lang ? manual.text : auto;
  const muted = mine ? "text-white/75 border-white/30" : "text-slate-500 border-slate-300/60";

  const translate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/conversations/${convId}/messages/${m.id}/translate?lang=${lang}`);
      if (data.same) toast(fr ? "Ce message est déjà en français" : "This message is already in English");
      else setManual(data);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  if (!text) {
    return (
      <>
        {m.body}
        {m.body && (
          <button type="button" onClick={translate} disabled={busy} data-testid={`message-translate-btn-${m.id}`}
            className={`mt-1 text-[11px] font-semibold flex items-center gap-1 opacity-70 hover:opacity-100 ${mine ? "text-white" : "text-slate-500 hover:text-[#F5551E]"}`}>
            {busy ? <Loader2 size={11} className="animate-spin" /> : <Languages size={11} />} {fr ? "Traduire" : "Translate"}
          </button>
        )}
      </>
    );
  }
  const from = lang === "fr" ? "en" : "fr";
  return (
    <span data-testid={`message-translated-${m.id}`}>
      {text}
      <span className={`block mt-1.5 pt-1.5 border-t text-[11px] ${muted}`}>
        <button type="button" onClick={() => setShowOrig((v) => !v)} data-testid={`message-original-toggle-${m.id}`} className="inline-flex items-center gap-1 font-semibold hover:underline">
          <Languages size={11} /> {fr ? (from === "en" ? "Traduit de l'anglais" : "Traduit du français") : `Translated from ${LANG_NAME.en[from]}`} · {showOrig ? (fr ? "masquer l'original" : "hide original") : (fr ? "voir l'original" : "show original")}
        </button>
        {showOrig && <span className="block mt-1 italic whitespace-pre-line" data-testid={`message-original-${m.id}`}>{m.body}</span>}
      </span>
    </span>
  );
};
